module.exports = __webpack_public_path__ + "img/img-2.6e14b9ed.png";